const fiFI = {
  navigation: {
    mydevice: "Oma laitteeni",
    mymobile: "Oma matkapuhelimeni"
  },
  photoorganiser: {
    navigation: {
      photos: "Valokuvat",
      favorites: "Suosikit",
      collections: "Kokoelmat",
      events: "Tapahtumat",
      latestuploads: "Viimeisimmät lataukset"
    },
    empty(source) {
      return "Sinulla ei ole kuvia kohteessa " + source
    }
  },
  mymobile: {
    title: "Saa puhelimesi kuvat hetkessä!",
    qrcode: {
      title: "Skannaa QR-koodi",
      subtitle: "(Sovellusta ei tarvitse asentaa)"
    },
    instruction: {
      title: "Aloitetaan!",
      step_1: "Avaa kamerasovellus",
      step_2: "Skannaa QR-koodi",
      step_3: "Seuraa ohjeita matkapuhelimellasi"
    }
  },
  layout: {
    flex: "Joustava",
    square: "Neliö"
  },
  calender: {
    allmonths: "Kaikki kuukaudet",
    allyears: "Kaikki vuodet",
    months: {
      january: "Tammikuu",
      february: "Helmikuu",
      march: "Maaliskuu",
      april: "Huhtikuu",
      may: "Toukokuu",
      june: "Kesäkuu",
      july: "Heinäkuu",
      august: "Elokuu",
      september: "Syyskuu",
      october: "Lokakuu",
      november: "Marraskuu",
      december: "Joulukuu"
    }
  },
  generic: {
    sortBy: "lajittele",
    selected: "valittu",
    done: "Lisää valokuvia",
    back: "Takaisin",
    images: "valokuvaa",
    removeall: "Poista kaikki",
    selection: "Valinta",
    date: "Päivämäärä",
    name: "Nimi",
    az: "Tiedostonimi  A-Z",
    za: "Tiedostonimi  Z-A",
    newestfirst: "Kuvauspäivä uusi-vanha",
    oldestfirst: "Kuvauspäivä vanha-uusi",
    photos: "valokuvaa",
    all: "Kaikki",
    yes: "kyllä",
    no: "ei",
    nodate: "Ei päivämäärää"
  },
  rangeText: {
    minMax(min, max) {
      return "Sinun on valittava " + min + " - " + max + " valokuvaa"
    },
    min(min) {
      return "Luodaksesi kirjan tarvitset vähintään " + min + " valokuvaa."
    },
    max(max) {
      return "Voit valita enintään " + max + " valokuvaa"
    }
  },
  addMorePhotos: "Lisää enemmän valokuvia",
  upload: {
    browseButton: "Lisää valokuvia",
    uploadlimit(maxSize) {
      return "Valokuvatiedoston on oltava pienempi kuin " + maxSize
    },
    dragImage: "tai vedä ja pudota kuvat tähän.",
    errors: {
      GENERIC_ERROR: "Jotain meni pieleen. Yritä myöhemmin uudelleen tai ota yhteyttä asiakaspalveluun.",
      EMPTY_FILE: "Kuvan viite katosi, lisää kuva uudelleen",
      MAX_FILE_SIZE: "Tiedoston on oltava pienempi kuin {0} Mt",
      UNSUPPORTED_FILE_TYPE: "Tiedostomuotoa ei tueta",
      MAX_IMAGE_RESOLUTION: "Tiedoston on oltava pienempi kuin {0} pikseliä",
      INVALID_IMAGE: "Tiedosto on rikki"
    },
    errorSummary(number) {
      return number + " tiedostoa ei voitu ladata"
    },
    errorDialog: {
      headline: "Hupsis!",
      ingress: "Seuraavia tiedostoja ei voitu ladata:",
      filenameColumn: "Tiedosto",
      reasonColumn: "Syy"
    },
    uploaded: "Ladattu",
    estimating: "Arvioidaan aikaa",
    estimatedleft: "Arvioitu aika jäljellä",
    ok: "OK",
    cancel: "Peruuta",
    details: "Tarkemmat tiedot"
  }
}

export default fiFI
